import gql from 'graphql-tag';

const externalOnboardingQueueQuery = gql`
  query ExternalOnboardingQueue(
    $view: String
    $search: String
    $from: String
    $to: String
    $sort: String
    $order: String
    $page: Int
    $size: Int
  ) {
    externalOnboardingQueue(
      view: $view
      search: $search
      from: $from
      to: $to
      sort: $sort
      order: $order
      page: $page
      size: $size
    ) {
      total
      page
      size
      items {
        flatRateOfferId
        flatRateOfferBatchId
        customerId
        status
        offerAcceptedDate
        dealerName
        dealerEmail
        dealerPhone
        createdAt
        completedAt
        updatedBy
        noteCount
        reason
        productType
        subscriptionPrice
      }
    }
  }
`;

export default externalOnboardingQueueQuery;
